import { runDemo } from "../shared/demoRunner";
import { createStarfieldScene } from "./scene";

runDemo({ createScene: createStarfieldScene });
